
import {
  Component,
  ComponentRef,
  DestroyRef,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { AbcListComponent, SelectionModeList, SreachModeList } from '@barthauer/abc/ui-components';
import { DxListModule, DxLoadIndicatorModule } from 'devextreme-angular';
import { DataSource, ArrayStore } from 'devextreme/common/data';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { DataService } from '../../../services/data.service';
import { FavoriteDataSource } from './favorite-dataSource';
import { FavoriteFilterListComponent } from './favorite-filter-list/favorite-filter-list.component';
import { FavoritesService } from './favorites.service';
import { BoxDetailViewModel, TypeFavorite } from './Model/box.viewModel';
import { ItemClickEvent } from 'devextreme/ui/list';
import { ObjectTypeNames } from '../../favorite-list/favorite-list.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.scss'],
  imports: [
    MatListModule,
    MatIconModule,
    FlexLayoutModule,
    DxListModule,
    DxLoadIndicatorModule,
    MatTooltipModule,
    AbcListComponent
],
  encapsulation: ViewEncapsulation.Emulated,
})
export class FavoritesComponent implements OnInit {
  @Output() onItemClicked: EventEmitter<ItemClickEvent> = new EventEmitter();
  @Input() ObjectTypeNames: ObjectTypeNames;
  public dataSource: DataSource;
  public sreachModeList = SreachModeList.Contains;
  public selectionModeList = SelectionModeList.Single;

  private ComponentRef: ComponentRef<FavoriteFilterListComponent>;
  private favoriteData: BoxDetailViewModel[];
  private filterList: Map<string | number, any>;
  private islistOpened: boolean = false;

  constructor(
    public readonly dataService: DataService,
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
    private readonly elementRef: ElementRef,
    private readonly favoritesService: FavoritesService,
    private readonly containerRef: ViewContainerRef,
    private readonly destroyRef: DestroyRef
  ) {
    this.registerIcons();
  }
  private registerIcons(): void {
    const icons: [string, string][] = [
      ['fav', 'assets/images/all_favorites.svg'],
      ['company', 'assets/images/company_fav.svg'],
      ['audAudit', 'assets/images/audit_fav.svg'],
      ['audBibMeasure', 'assets/images/measure.svg'],
      ['audBibResponse', 'assets/images/answer.svg'],
      ['audBibQuestion', 'assets/images/question.svg'],
      ['audLibrary', 'assets/images/library.svg'],
      ['audBibCategory', 'assets/images/category.svg'],
      ['subProject', 'assets/images/subProject.svg'],
      ['measure', 'assets/images/measure.svg'],
    ];

    icons.forEach(([name, path]) => {
      this.iconRegistry.addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(path));
    });
  }

  ngOnInit(): void {
    if (this.ObjectTypeNames && Object.keys(this.ObjectTypeNames).length > 0) {
      this.favoritesService.appObjectTypesKeys = Object.keys(this.ObjectTypeNames);
    }
    this.favoritesService.getDataSource().subscribe((allFavorites: FavoriteDataSource) => {
      this.favoriteData = Array.from(allFavorites.favorites.values());
      this.fillDataSource(this.favoriteData);
    });
  }

  private fillDataSource(listFavorites: BoxDetailViewModel[]): void {
    if (listFavorites.length > 0) {
      listFavorites = listFavorites.filter((favorite) => {
        if (this.ObjectTypeNames[favorite.ParentObjectType] !== undefined) {
          return favorite;
        }
      });
    }
    this.filterList = this.fillObjectTypeName(listFavorites);
    this.dataSource = new DataSource({
      store: new ArrayStore({
        data: listFavorites,
        key: 'ParentObjectTypeName',
      }),
      sort: ['DisplayText', 'key'],
      group: 'ParentObjectTypeName',
      searchExpr: ['DisplayText', 'ParentObjectTypeName'],
    });
  }

  private fillObjectTypeName(listFavorites: BoxDetailViewModel[]): Map<string | number, any> {
    const filterList: Map<string | number, any> = new Map<string | number, any>();
    filterList.set('All', { Name: 'All', Icon: 'fav' });
    if (listFavorites.length > 0) {
      listFavorites.forEach((favorite) => {
        if (this.ObjectTypeNames[favorite.ParentObjectType] !== undefined) {
          if (!filterList.has(favorite.ParentObjectType)) {
            filterList.set(this.ObjectTypeNames[favorite.ParentObjectType], {
              Name: this.ObjectTypeNames[favorite.ParentObjectType],
              Icon: TypeFavorite[this.ObjectTypeNames[favorite.ParentObjectType]],
            });
          }
          favorite.ObjectType = favorite.ParentObjectType;
          favorite.ParentObjectTypeName = this.dataService.res(
            'Favorites-' + this.ObjectTypeNames[favorite.ParentObjectType]
          );
        }
      });
    }
    return filterList;
  }

  private createComponent(parent: HTMLElement): void {
    this.ComponentRef = this.containerRef.createComponent(FavoriteFilterListComponent);
    parent.appendChild(this.ComponentRef.location.nativeElement);
    const filterList = this.ComponentRef.instance;
    filterList.filteredBy = 'All';
    filterList.filterList = this.filterList;
    filterList.onButtonClick.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      filterList.filteredBy = event;
      this.onFilterListClicked(this.dataService.res('Favorites-' + event));
    });
  }

  private onFilterListClicked(event: string): void {
    if (event !== this.dataService.res('Favorites-All')) {
      this.dataSource.filter(['ParentObjectTypeName', '=', event]);
    } else {
      this.dataSource.filter(null);
    }
    this.dataSource.load();
  }

  public contentReady(): void {
    if (!this.islistOpened) {
      this.islistOpened = true;
      const listBoxContent = this.elementRef.nativeElement.querySelector('.dx-scrollview-content');
      const parent = document.createElement('div');
      parent.className = 'filterList';
      parent.setAttribute('id', 'forViewRef');
      listBoxContent.appendChild(parent);
      listBoxContent.insertAdjacentElement('beforebegin', parent);
      this.createComponent(parent);
    }
  }

  public itemClicked(event: ItemClickEvent): void {
    this.onItemClicked.emit(event);
  }
}
